import { render } from "./AddPage.vue?vue&type=template&id=ac80cf02&scoped=true"
import script from "./AddPage.vue?vue&type=script&lang=js"
export * from "./AddPage.vue?vue&type=script&lang=js"

import "./AddPage.vue?vue&type=style&index=0&id=ac80cf02&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac80cf02"]])

export default __exports__